require('./bootstrap');

$(function () {
    let bLazy = new Blazy({
        selector: '.b-lazy',
        loadInvisible: false,
        offset: 500,
        breakpoints: [{
            width: 420, // Max-width
            src: 'data-src-small',
            offset: 300
        }]
        , success: function (element) {
            setTimeout(function () {
                // We want to remove the loader gif now.
                var parent = element.parentNode;
                parent.className = parent.className.replace(/\bloading\b/, '');
            }, 0);
        }
    });

    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);

    if(urlParams.get('print')){
        bLazy.load(document.getElementsByClassName("b-lazy"), true);
    }

    let btn = document.querySelector('.show-btn')
    if (btn) {
        btn.addEventListener('click', () => {
            bLazy.revalidate();
        })
    }


    document.addEventListener('blazy:revalidate', (event) => {
        bLazy.revalidate();
    });
});

$(function () {
    $('.side-close, .side-overlay').on('click', function () {
        $('body').removeClass('left-open').removeClass('right-open');
    });

    $('#navbar-toggle').on('click', function () {
        $('body').removeClass('right-open').addClass('left-open');
    });

    $('#acc-toggle').on('click', function () {
        $('body').removeClass('left-open').addClass('right-open');
    });
    $(window).scroll(function () {
        var top = $(window).scrollTop();

        if (top > 5) {
            $('#top-menu').addClass('sticked');
        } else {
            $('#top-menu').removeClass('sticked');
        }
    });

    $(window).scroll();
});
